import React,{useState,useEffect} from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow
        ,Card,TextField,Box, Paper,Tooltip,IconButton, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import moment from 'moment';
const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    estiloCard:{
        width: '63rem',
        boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
       // color:'#4a4a4a',
        display:'block',
        padding:'.5rem',
        maxHeight:'100%',
        minHeight: 280,
        marginRight:'.5rem'
    },
    formControl:{
        boxSizing:'border-box',
        fontSize:'1rem',
        position:'relative',
        marginBottom:'1em'
    },
    container: {
      width: '62rem',
      minHeight: '25rem',
      //minWidth:'100%',
    },
    tablaContainer: {
        width: '62rem',
        maxHeight: '31.5rem',
        minHeight: 280,
        //minWidth:'100%',
      },
    totalEstilo:{
        fontSize:'1.25rem',
        fontWeight:'bold'
    },
    tituloEstilo:{
        paddingBottom:'.25rem',
        fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });
  const columnas=[                    
    {
      id:1, titulo:"Municipio", alinear:'center'
    },     
    { id:5, titulo:"Hombre", alinear:'center' },      
    { id:6, titulo:"Mujer", alinear:'center' },      
    { id:7, titulo:"No Binario", alinear:'center' },      
   /*  {
      id:2, titulo:"Pendiente", alinear:'center'
    },      
    {
      id:3, titulo:"Valido", alinear:'center'
    },      
    {
      id:4, titulo:"Rechazado", alinear:'center'
    },   */    
  ];

const alturaCont = window.innerHeight<937 ? window.innerHeight-250 : window.innerHeight-270

export default function TablaTarea({listSolicitud,registro, setRegistro, }){    
  const classes = useStyles();    
  const [promotor, setPromotor] = useState({nombre:""})
  const [seleccion, setSeleccion] = useState(null)
  const [datos,setDatos] = useState([]);     
  const [totalGen,setTotalGen] = useState([]);     
  const auxCol=process.env.REACT_APP_Fondo_Color
  const {nombre} = promotor;    
  useEffect(()=>{
     
      if (listSolicitud.length!==0 ) {                
         setDatos(listSolicitud)  
         //setTotalGen(aux)
       }else
       {
         setDatos([])
       }          

    //la siguiente linea puede generar errores o no en el useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listSolicitud])          

  const onChangeTable =(regis)=>{    
    
      setRegistro(regis)  
                        
  }

  function filtro(){        
    let auxCadena=nombre.trim();       
    let info=[];                        
    let aux=  datos.filter((dat)=>dat.nombreReg.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
    info=aux 
    
           
    return TablaEstr(info);
  }

  const celda = (alinear, estilo, contenido,index) => {
    return (
    <TableCell align={alinear} key={index} className={classes.tableCell} 
        padding={'none'} style={estilo} >
        {contenido}
    </TableCell>)
  }

  const CelTitl=({index,titulo,aline})=> celda(aline?aline:"center", {backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 

  const colorStatus=(descr, color)=>{  
    return(
    <Box display={"flex"}  justifyContent="flex-start" style={{textAlign:"left",alignItems:"center",fontSize:"12px"}}>            
    <FiberManualRecordIcon size="small" style={{color:color,}}/>      
      {`${descr}`}
      
    </Box>)
  }

  function TablaEstr(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
      <Table stickyHeader aria-label="sticky table">
        <TableHead >    

         { 
         <TableRow>
          <CelTitl index={1} titulo={"" } aline={"center"} />       
          <CelTitl index={2} titulo={"Sucursal" } aline={"center"} />                   
          <CelTitl index={3} titulo={<span>Materia <strong>{}</strong></span>} aline={"center"} />         
          <CelTitl index={4} titulo={<span>Estatus </span>} aline={"center"} />        
          {/* <CelTitl index={5} titulo={<span >FechaCaptura </span>} aline={"center"} />   */}
          <CelTitl index={6} titulo={<span > F. Inicio </span>} aline={"center"} />  
          <CelTitl index={7} titulo={<span >F. Fin </span>} aline={"center"} />  
          {/* <CelTitl index={8} titulo={<span>Capturista </span> } aline={"center"} />          */}    
          <CelTitl index={9} titulo={<span>Destinatario </span>  } aline={"center"} />                                                                                             
          <CelTitl index={10} titulo={<span >Descripción </span>} aline={"center"} />       
          <CelTitl index={11} titulo={<span >Anotación </span>} aline={"center"} />                 
          </TableRow>
           }                   
        </TableHead>  
        <TableBody> 
        {/* <TableRow className={classes.tableRow} selected={ registro?.Id === 0} 
          classes={{ hover: classes.hover, selected: classes.selected }} 
          key={0} onClick={ () => onChangeTable({Id:0,Num:0}) }  
        >   
         
          {celda("center", {width:"2rem"}, "GENERAL",0) }                                                                  
        </TableRow> */}
        {auxDatos.map((elemnto,index) => {  
          const auxVal=registro?.Id === elemnto.Id ?true:false          
          const auxFecha=moment(elemnto.freg).format("DD/MM/YYYY HH:mm");                                         
          const auxFIni=moment(elemnto.fIni).format("DD/MM/YYYY");    
          const auxFfin=moment(elemnto.fFin).format("DD/MM/YYYY");    
          return (                  
          <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index+1} onClick={ () => onChangeTable(elemnto) }  
          > 
            {celda("center", {width:"2rem"}, elemnto.Id,index) }
            {celda("left", {width:"4rem", fontSize:"12px",  }, elemnto.sucurNom ,index+2) }            
            {celda("center", {width:"5rem"}, elemnto.tipoNom,index+3) }
            {celda("left", {width:"5rem"},  colorStatus(elemnto.statNom,elemnto.statCol),index+4) }
            {/* celda("center", {width:"7rem"}, auxFecha,index+5)  */}  
            {celda("center", {width:"7rem"}, auxFIni,index+6) }  
            {celda("center", {width:"7rem"}, auxFfin,index+7) }  
            {/* celda("left", {width:"8rem"},  elemnto.usrCapNom ,index+8)  */}                    
            {celda("left", {width:"6rem"}, elemnto.usrDesNom ,index+9) }                                                
            {celda("left", {width:"10rem", fontSize:"12px"}, elemnto.descr,index+10) }     
            {celda("left", {width:"10rem",paddingRight:".3rem", fontSize:"12px"}, elemnto.anotacion,index+11) }                 
          </TableRow>              
          );                        
          })
        }                                                
        </TableBody>
      </Table>
    </TableContainer>        
    ); 
  }
                   
    const contenido = nombre.length > 0 ? (filtro()):(TablaEstr(datos));    
    const llamada= datos.length !== 0 ?(contenido):(<Box style={{paddingTop:1+'rem'}}>
                                    <Typography variant="h5" component="h5">No contiene datos</Typography>
                                    </Box>)
                                                                                
                           
                                
  return (
  <Box display={'flex'} flexDirection="row" style={{height: '34rem',marginLeft:"1rem"}}>
    <Card className={classes.estiloCard} style={{height:window.innerHeight-140}}>                              
      {llamada}   
    </Card>

  </Box>                    
  );
}